module.exports = __webpack_public_path__ + "img/karaage_teisyoku.2185fe19.jpg";